import * as actionTypes from "../../actionLabels/referenceNo/referenceNo";

export const getReferenceNoRequest = () => ({
  type: actionTypes.GET_REFERENCE_NO_REQUEST,
});

export const getReferenceNoSuccess = (data) => ({
  type: actionTypes.GET_REFERENCE_NO_SUCCESS,
  payload: data,
});

export const getReferenceNoFailure = (error) => ({
  type: actionTypes.GET_REFERENCE_NO_FAILURE,
  payload: error,
});

